<template>
  <div class="wallet-withdraw">
    <div class="wallet-title">
      <div class="amount">{{ walletBalance | money }}</div>
      <div class="desc">可提现余额</div>
    </div>
    <div class="withdraw-rule">
      <p class="withdraw-rule-sub-title">提现规则</p>
      <ul class="withdraw-rule-list">
        <li>1.每月8日之前提交提现申请；</li>
        <li>2.财务8日之后陆续处理；</li>
        <li>3.每月只能提交一次；</li>
        <li v-if="userInfo.type === 2">4.需要提前邮寄发票</li>
      </ul>
    </div>
    <van-form class="withdraw-form" @submit="formSubmit" label-width="7em">
      <van-field
        label="提现金额"
        :value="withdraw.tradeMoney"
        type="number"
        placeholder="请输入结算金额"
        :rules="[{ required: true, message: '请填写提现金额' }]"
        @input="withdraw.tradeMoney = $event.match(/^\d*(\.?\d{0,2})/g)[0]"
      />
      <van-field v-if="userInfo.type === 2" label="发票快递单号" v-model="withdraw.expressNumber" placeholder="请输入发票快递单号" />
      <div class="form-submit">
        <van-button size="small" :loading="loading" type="primary" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Decimal } from 'decimal.js'
import { balance, withdrawal } from '@/api/wallet';
export default {
  data() {
    return {
      loading: false,
      walletBalance: '',
      withdraw: {
        tradeMoney: '',
        expressNumber: undefined
      }
    }
  },
  created() {
    this.getWalletBalance();
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    /**
     * 获取钱包余额
     */
    getWalletBalance() {
      balance().then(res => {
        if (res.errcode === 0) {
          this.walletBalance = res.data.withdrawalBalance;
        }
      })
    },
    formSubmit() {
      const { tradeMoney } = this.withdraw;
      this.loading = true;
      withdrawal({ ...this.withdraw, tradeMoney: new Decimal(tradeMoney).mul(100).toNumber() }).then(res => {
        this.loading = false;
        if (res.errcode === 0) {
           this.$toast({
             type: 'success',
             message: res.errmsg
           });
           this.$router.push({ name: 'Wallet' });
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wallet-withdraw { background-color: #fff;
  .wallet-title { padding-top: 20px; padding-bottom: 15px; color: #333;
    .amount { text-align: center; font-size: 32px; font-weight: 650; overflow: hidden; word-wrap:break-word; word-break:break-all; }
    .desc { text-align: center; font-size: 14px; }
  }
  .withdraw-rule {
    padding: 0 10px 45px;
    color: rgb(51, 51, 51);
    p { margin: 10px 0; font-size: 13px; }
    &-list { font-size: 13px; }
  }
  .withdraw-form {
    .van-field {
      &:first-of-type {
        &::before  {
          content: '';
          position: absolute;
          width: 100%;
          left: 16px;
          top: 0;
          border-top: 1px solid #ebedf0;
          transform: scaleY(.5);
        }
      }
    }
    .form-submit { text-align: center; margin-top: 20px; padding-bottom: 20px;
      .van-button { padding: 0 30px; }
    }
  }
}
</style>